import React, { useEffect, useState } from 'react';
import ApiServices from '../../../Utils/ApiServices/ApiServices';
import { getDecryptedAccessToken } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress
} from '@mui/material';

const MembershipGroupsDetails = ({ groupDetails }) => {
  const accessToken = getDecryptedAccessToken();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGroupMembers = async () => {
    if (!groupDetails?.group_id) return;

    try {
      const response = await ApiServices.get(
        `/apis/default/api/membership/${groupDetails.group_id}/patient`,
        {
          
            Authorization: `Bearer ${accessToken}`,
          
        }
      );
      setMembers(response.data || []);
    } catch (error) {
      console.error('Error fetching group members:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroupMembers();
  }, [groupDetails]);

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Members of Group: {groupDetails?.group_name || groupDetails?.group_id}
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Name</strong></TableCell>
                <TableCell><strong>Plan Tier</strong></TableCell>
                <TableCell><strong>Start Date</strong></TableCell>
                <TableCell><strong>End Date</strong></TableCell>
                <TableCell><strong>Status</strong></TableCell>
                <TableCell><strong>Active</strong></TableCell>
                <TableCell><strong>Created At</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.map((member) => (
                <TableRow key={member.id}>
                  <TableCell>{member.fname} {member.lname}</TableCell>
                  <TableCell>{member.plan_tier}</TableCell>
                  <TableCell>{member.start_date}</TableCell>
                  <TableCell>{member.end_date}</TableCell>
                  <TableCell>{member.approval_status}</TableCell>
                  <TableCell>{member.active ? 'Yes' : 'No'}</TableCell>
                  <TableCell>{member.created_at}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default MembershipGroupsDetails;
